export class ObjectPool<T> {
    private _pool: T[];
    private _constructor: () => T;

    constructor(pObjectConstructor: () => T) {
        this._constructor = pObjectConstructor;
        this._pool = new Array<T>();
    }

    public getObject(): T {
        if (this._pool.length === 0) {
            this._pool.push(this._constructor());
        }
        return this._pool.pop()!;
    }

    public returnObject(pObj: T): void {
        this._pool.push(pObj);
    }
}
